// Search Header Functionality - Modified for Impulse Theme Compatibility
class SearchHeader {
  constructor() {
    // 创建元素
    this.searchContainer = document.querySelector(
      ".site-header__search-container"
    );
    this.searchOverlay = document.createElement("div");
    this.searchOverlay.className = "search-overlay";
    document.body.appendChild(this.searchOverlay);

    // 初始化
    if (this.searchContainer) {
      this.initEvents();
      this.checkMobileMenu();
    }
  }

  initEvents() {
    // 搜索按钮点击
    document.querySelectorAll(".js-search-header").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        this.showSearch();
      });
    });

    // 关闭按钮
    const closeBtn = document.querySelector(".js-search-header-close");
    if (closeBtn) {
      closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.hideSearch();
      });
    }

    // 点击半透明层关闭
    this.searchOverlay.addEventListener("click", (e) => {
      if (e.target === this.searchOverlay) {
        this.hideSearch();
      }
    });

    // ESC键关闭
    document.addEventListener("keydown", (e) => {
      if (
        e.key === "Escape" &&
        document.body.classList.contains("search-open")
      ) {
        this.hideSearch();
      }
    });
  }

  // 处理移动端菜单冲突
  checkMobileMenu() {
    const mobileMenu = document.querySelector(".mobile-nav-wrapper");
    if (mobileMenu) {
      mobileMenu.style.zIndex = "998";
    }
  }

  showSearch() {
    document.body.classList.add("search-open");
    this.searchContainer.style.display = "block";
    this.searchOverlay.style.display = "block";

    // 强制回流
    void this.searchContainer.offsetWidth;

    // 添加动画
    this.searchContainer.classList.add("active");
    this.searchOverlay.style.opacity = "1";

    // 设置合适的高度
    this.searchContainer.style.height = "auto";
    this.searchContainer.style.maxHeight = "80vh"; // 限制最大高度

    // 延迟聚焦确保动画完成
    setTimeout(() => {
      const input = document.querySelector(".site-header__search-input");
      if (input) {
        input.focus();
        input.select();
      }

      // 确保热门搜索样式正确
      const popularSearches = document.querySelectorAll(".popular-search-item");
      popularSearches.forEach((item) => {
        item.classList.add("active");
      });
    }, 300);
  }

  hideSearch() {
    // 移除活动状态类
    this.searchContainer.classList.remove("active");
    this.searchOverlay.style.opacity = "0";

    // 等待动画完成后隐藏元素
    setTimeout(() => {
      document.body.classList.remove("search-open");
      this.searchContainer.style.display = "none";
      this.searchOverlay.style.display = "none";
    }, 300);
  }
}

// 页面加载后初始化
if (document.readyState === "complete") {
  new SearchHeader();
} else {
  document.addEventListener("DOMContentLoaded", () => {
    new SearchHeader();
  });
}

// 处理主题编辑器事件
document.addEventListener("shopify:section:load", () => {
  new SearchHeader();
});
